'use client'

import { useIsScrolled } from '@/hooks/useIsScrolled'
import { cn } from '@/lib/styles'

export function TopGradientBackdrop() {
  const isScrolled = useIsScrolled()

  return (
    <div
      aria-hidden
      className={cn(
        'absolute top-0 left-0 right-0 h-264 lg:h-175 -z-10 pointer-events-none',
        'bg-linear-to-b from-peach-200 via-peach-100 to-transparent',
        'transition-opacity duration-300',
        isScrolled ? 'opacity-0' : 'opacity-100',
      )}
    />
  )
}
